// This file is auto-generated by 'pnpm rebuild:icons'
import type { TemplateOnlyComponent } from '@ember/component/template-only';

import type { Signature } from './types.ts';

const IconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='23.021'
    height='19.616'
    viewBox='0 0 23.021 19.616'
    ...attributes
  ><path
      fill='var(--icon-color, #000)'
      d='M11.575 6.955a7.63 7.63 0 0 0-4.625 4.621.9.9 0 0 1-.86.614.9.9 0 0 1-.859-.614A7.63 7.63 0 0 0 .61 6.955a.908.908 0 0 1 0-1.719A7.63 7.63 0 0 0 5.235.61a.908.908 0 0 1 1.719 0 7.63 7.63 0 0 0 4.621 4.621.908.908 0 0 1 0 1.719zm5.475 7.8a5.1 5.1 0 0 1-2.478-2.479 1 1 0 0 0-1.81 0 5.1 5.1 0 0 1-2.478 2.478 1 1 0 0 0 0 1.809 5.1 5.1 0 0 1 2.478 2.479 1 1 0 0 0 1.81 0 5.1 5.1 0 0 1 2.478-2.483 1 1 0 0 0 0-1.809zm5.46-8.035a3.94 3.94 0 0 1-1.911-1.91.87.87 0 0 0-.8-.51.87.87 0 0 0-.8.509 3.94 3.94 0 0 1-1.911 1.91.878.878 0 0 0 0 1.594 3.94 3.94 0 0 1 1.91 1.91.87.87 0 0 0 .8.509.87.87 0 0 0 .8-.51 3.94 3.94 0 0 1 1.91-1.91.878.878 0 0 0 0-1.594z'
    /></svg>
</template>;

// @ts-expect-error this is the only way to set a name on a Template Only Component currently
IconComponent.name = 'Sparkle';
export default IconComponent;
